module.exports = __webpack_public_path__ + "static/img/icon_payment_notice_orange.68e0951.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_payment_notice_orange.svg
// module id = nYJR
// module chunks = 10